export default {"src":"/_next/static/media/share-blue.da103209.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};